module.exports = __webpack_public_path__ + "h5/img/f2.b1b8d988.jpg";